import "./AddVote.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../loader/Loader";
import { useEffect, useState } from "react";
import {
  getTypes,
  getCategories,
} from "../../../redux/features/categoryAndType/categoryAndTypeSlice";
import { RESET_PROD, createVote } from "../../../redux/features/vote/voteSlice";
import { toast } from "react-toastify";
import VoteForm from "../voteForm/VoteForm";

const initialState = {
  title: "",
  optionOne: "",
  optionTwo: "",
  optionThree: "",
};

const AddVote = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [vote, setVote] = useState(initialState);

  const { isLoading, message } = useSelector((state) => state.vote);

  const { title, optionOne, optionTwo, optionThree } = vote;

  const saveVote = async (e) => {
    e.preventDefault();

    const formData = {
      title,
      optionOne,
      optionTwo,
      optionThree,
    };
    // console.log(formData);
    await dispatch(createVote(formData));

    // navigate("/admin/all-posts");
  };

  useEffect(() => {
    if (message === "Vote created Successful") {
      navigate("/admin/all-votes");
    }
    // dispatch(RESET_PROD());
  }, [message, navigate, dispatch]);

  return (
    <section>
      <div className="container">
        {isLoading && <Loader />}
        <h2 className="mt">Add New Post</h2>

        <VoteForm
          saveVote={saveVote}
          vote={vote}
          setVote={setVote}
          isEditing={false}
        />
      </div>
    </section>
  );
};
export default AddVote;
